var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { PermissionsWrapper } from '@project/components/PermissionsWrapper';
import { setModalVisibilityOverride } from '../../containers/Root/actions';
import { selectModalsVisibility, selectModalsOverride, makeSelectOrganization, } from '../../containers/Root/selectors';
import { push } from 'connected-react-router';
import ConfigureAccountModal from '../../containers/ConfigureAccountModal';
import UpdateDevPlanOrPaymentModal from '../../containers/UpdateDevPlanModal';
import { ContactSupportModal } from '../ContactSupportModal';
import { SUPPORT_MODAL_TYPES } from '../ContactSupportModal/models';
import { ModalType } from '../../containers/Root/models';
export var ModalRenderer = function () {
    var dispatch = useDispatch();
    var organization = useSelector(makeSelectOrganization());
    var modalType = useSelector(selectModalsVisibility());
    var overRide = useSelector(selectModalsOverride());
    useEffect(function () {
        if (organization.id) {
            dispatch(setModalVisibilityOverride(true));
        }
    }, [dispatch, organization.id]);
    var closeModal = function () { return dispatch(setModalVisibilityOverride(false)); };
    var completeConfig = function () {
        dispatch(push("/organizations/".concat(organization.id, "/apps")));
        dispatch(setModalVisibilityOverride(false));
    };
    var renderModals = function (type) {
        switch (type) {
            case ModalType.WELCOME:
                return (_jsx(PermissionsWrapper, __assign({ multiTargets: [
                        "org:".concat(organization.id, ":orgadmin"),
                        'partner:123:organizations',
                    ], action: "create", hideOnDisable: true }, { children: _jsx(ConfigureAccountModal, { open: overRide, closeModal: closeModal, completeConfig: completeConfig, type: ModalType.WELCOME }) })));
            case ModalType.CONFIGURE:
                return (_jsx(PermissionsWrapper, __assign({ multiTargets: [
                        "org:".concat(organization.id, ":orgadmin"),
                        'partner:123:organizations',
                    ], action: "create", hideOnDisable: true }, { children: _jsx(ConfigureAccountModal, { open: overRide, closeModal: closeModal, completeConfig: completeConfig, type: ModalType.CONFIGURE }) })));
            case ModalType.SELECT:
                return (_jsx(UpdateDevPlanOrPaymentModal, { open: overRide, organization: organization, closeModal: closeModal }));
            case ModalType.PAYMENT:
                return (_jsx(UpdateDevPlanOrPaymentModal, { open: overRide, organization: organization, closeModal: closeModal, paymentModal: true }));
            case ModalType.CONTACT:
                return (_jsx(ContactSupportModal, { isOpen: overRide, closeModal: closeModal, supportType: SUPPORT_MODAL_TYPES.DEV_PLAN, orgId: organization === null || organization === void 0 ? void 0 : organization.id }));
            default:
                return;
        }
    };
    return renderModals(modalType) || null;
};
